
    import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
    import Util from '../../../lib/util'
    import AbpBase from '../../../lib/abpbase'

    import userList from '@/store/entities/userinfo'
    import Enums from '@/lib/enums'
    import appconst from '@/lib/appconst';
    class Packed {
        safestockNumber: number;
    }
    @Component
    export default class AddStockModule extends AbpBase {
        @Prop({ type: Boolean, default: false }) value: boolean;
        selectuser: userList = new userList();
        user: Array<userList> = [];
        automaticJump: boolean;
        PackedModel: Packed = new Packed();

        created() {

        }


        async check() {

            var id = this.$store.state.frontstockproduct.id;
            await this.$store.dispatch({
                type: 'frontstockproduct/EditSafeStockNum',
                data: { id: id, safestockNumber: this.PackedModel.safestockNumber }
            });

            //var timestamp1 = (new Date()).valueOf().toString();
            //if (this.automaticJump) {
            //    //this.$Modal.success({ title: "打包成功", content: "即将跳转到【快递单号入库页面】！" });
            //    this.$router.push({ name: 'intoLogistics', params: { JumpPage: timestamp1 } });
            //}
            (this.$refs.packForm as any).resetFields();
            this.$emit('save-success');
            this.$emit('input', false);
        }


        cancel() {
            (this.$refs.packForm as any).resetFields();
            this.$emit('input', false);
        }
        visibleChange(value: boolean) {
            if (!value) {
                this.$emit('input', value);
            } else {
                this.$set(this.PackedModel, "safestockNumber", this.$store.state.frontstockproduct.safeStockNum);
            }
        }
    }
